import i18n from 'i18next';
// i18next-http-backend v4: default-export plugin + `backend.loadPath` are unchanged
// from v1; v4 loads via the native `fetch` API (no cross-fetch dependency).
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    detection: {
      order: ['cookie', 'htmlTag'],
      lookupCookie: 'MX_LOCALE'
    },
    backend: {
      loadPath: '/locales/{{lng}}/translations.json'
    },
    interpolation: {
      escapeValue: false,
      formatSeperator: ','
    },
    react: {
      wait: true
    }
  });

export default i18n;
